(function (root) {
  const fold = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const groups = ['families','seasons','brands','sizes'];
  const params = {families:'duftwelt',seasons:'jahreszeit',brands:'marke',sizes:'groesse',query:'suche',min:'preis_min',max:'preis_max',sort:'sortierung'};
  function matchingVariants(p,s={}) {
    return p.variants.filter(v => (!s.sizes?.length || s.sizes.includes(v.size)) &&
      ((s.min == null && s.max == null) || (v.price > 0 && (s.min == null || v.price >= s.min) && (s.max == null || v.price <= s.max))));
  }
  function selectProducts(products,s={}) {
    const result=products.filter(p => {
      if (s.families?.length && !s.families.some(x=>p.families.includes(x))) return false;
      if (s.seasons?.length && !s.seasons.some(x=>p.seasons.includes(x))) return false;
      if (s.brands?.length && !s.brands.includes(p.brand)) return false;
      const text=fold([p.name,p.brand,...p.notes,...p.families].join(' '));
      if (!fold(s.query).split(/\s+/).filter(Boolean).every(q=>text.includes(q))) return false;
      return matchingVariants(p,s).length > 0;
    });
    const price=p=>Math.min(...matchingVariants(p,s).filter(v=>v.price>0).map(v=>v.price));
    if(s.sort==='title') result.sort((a,b)=>a.name.localeCompare(b.name,'de'));
    if(s.sort==='price-asc'||s.sort==='price-desc') result.sort((a,b)=>{
      const av=price(a),bv=price(b);
      if(!Number.isFinite(av))return Number.isFinite(bv)?1:0;
      if(!Number.isFinite(bv))return -1;
      return s.sort==='price-asc'?av-bv:bv-av;
    });
    return result;
  }
  function readState(url) {
    const u=new URL(url),s={};
    groups.forEach(k=>s[k]=u.searchParams.getAll(params[k]));
    ['query','sort'].forEach(k=>s[k]=u.searchParams.get(params[k])||'');
    ['min','max'].forEach(k=>{const v=u.searchParams.get(params[k]);if(v!==null&&v!==''&&Number.isFinite(Number(v)))s[k]=Math.max(0,Math.round(Number(v)*100));});
    return s;
  }
  function writeState(url,s) {
    const u=new URL(url);
    Object.values(params).forEach(k=>u.searchParams.delete(k));
    Object.entries(params).forEach(([k,key])=>{
      if(groups.includes(k)) (s[k]||[]).forEach(v=>u.searchParams.append(key,v));
      else if(s[k]!=null&&s[k]!=='')u.searchParams.set(key,['min','max'].includes(k)?String(s[k]/100):s[k]);
    });
    return u;
  }
  const api = { selectProducts, matchingVariants, readState, writeState };
  if (typeof module !== 'undefined') module.exports = api;
  root.GdoCatalog = api;
  if(typeof document==='undefined')return;
  function init(section) {
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    const cards=[...section.querySelectorAll('[data-scent]')];
    const products=cards.map(c=>{const p=JSON.parse(c.dataset.scent);return {...p,families:p.families||[],seasons:p.seasons||[],notes:p.notes||[],element:c};});
    const form=section.querySelector('[data-filter-form]'),grid=section.querySelector('[data-catalog-grid]');
    const sort=section.querySelector('[data-sort]'),count=section.querySelector('[data-result-count]');
    const quick=[...section.querySelectorAll('[data-quick]')],active=section.querySelector('[data-active]');
    const money=new Intl.NumberFormat('de-CH',{style:'currency',currency:section.dataset.currency||'CHF'});
    let state=readState(location.href);
    function sync() {
      form.querySelectorAll('input[type=checkbox]').forEach(i=>i.checked=(state[i.name]||[]).includes(i.value));
      form.elements.query.value=state.query||'';
      form.elements.min.value=state.min==null?'':state.min/100;
      form.elements.max.value=state.max==null?'':state.max/100;
      sort.value=['title','price-asc','price-desc'].includes(state.sort)?state.sort:'';
    }
    function draw(push=false) {
      const selected=selectProducts(products,state), visible=new Set(selected.map(p=>p.id));
      products.forEach(p=>{p.element.hidden=!visible.has(p.id);});
      selected.forEach(p=>{
        grid.append(p.element);
        const prices=matchingVariants(p,state).filter(v=>v.price>0).map(v=>v.price);
        p.element.querySelector('[data-card-price]').textContent=prices.length?'Ab '+money.format(Math.min(...prices)/100):section.dataset.pending;
        p.element.querySelectorAll('[data-variant]').forEach(el=>{
          const v=p.variants.find(x=>String(x.id)===el.dataset.variant);
          el.classList.toggle('is-match',Boolean(v&&matchingVariants(p,state).includes(v)&&(state.sizes?.length||state.min!=null||state.max!=null)));
        });
      });
      count.textContent=selected.length+' '+(selected.length===1?section.dataset.singular:section.dataset.plural);
      section.querySelector('[data-empty]').hidden=selected.length>0;
      quick.forEach(b=>b.setAttribute('aria-pressed',String((state.families||[]).includes(b.dataset.quick))));
      active.replaceChildren();
      const chips=[];
      groups.forEach(k=>(state[k]||[]).forEach(v=>chips.push({label:v,remove:()=>state[k]=state[k].filter(x=>x!==v)})));
      if(state.query)chips.push({label:'Suche: '+state.query,remove:()=>state.query=''});
      if(state.min!=null||state.max!=null)chips.push({label:'Preis: '+(state.min==null?'0':state.min/100)+'–'+(state.max==null?'∞':state.max/100)+' CHF',remove:()=>{delete state.min;delete state.max;}});
      chips.forEach((c,index)=>{const b=document.createElement('button');b.type='button';b.textContent=c.label+' ×';b.setAttribute('aria-label',c.label+' entfernen');b.addEventListener('click',()=>{c.remove();sync();draw(true);const remaining=active.querySelectorAll('button');(remaining[Math.min(index,remaining.length-1)]||sort).focus();});active.append(b);});
      section.querySelectorAll('[data-reset]').forEach(b=>b.hidden=!chips.length);
      if(push){const u=writeState(location.href,state);history.pushState(null,'',u);}
    }
    function changed() {
      groups.forEach(k=>state[k]=[...form.querySelectorAll('input[name="'+k+'"]:checked')].map(i=>i.value));
      state.query=form.elements.query.value.trim();
      ['min','max'].forEach(k=>{const i=form.elements[k];if(i.value!==''&&i.validity.valid)state[k]=Math.round(Number(i.value)*100);else delete state[k];});
      state.sort=sort.value;draw(true);
    }
    form.addEventListener('submit',e=>{e.preventDefault();changed();});
    form.addEventListener('change',changed);
    sort.addEventListener('change',changed);
    quick.forEach(b=>b.addEventListener('click',()=>{state.families=(state.families||[]).includes(b.dataset.quick)?state.families.filter(v=>v!==b.dataset.quick):[...(state.families||[]),b.dataset.quick];sync();draw(true);}));
    section.querySelectorAll('[data-reset]').forEach(b=>b.addEventListener('click',()=>{state={};sync();draw(true);}));
    addEventListener('popstate',()=>{state=readState(location.href);sync();draw();});
    const details=section.querySelector('[data-filter-panel]'),media=matchMedia('(min-width: 990px)');
    const resize=()=>{details.open=media.matches;};media.addEventListener('change',resize);resize();
    sync();draw();section.classList.add('is-enhanced');
  }
  const boot=()=>document.querySelectorAll('[data-gdo-catalog]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})(globalThis);

